(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.Covid19",
                {
                    url: "/COVID-19",
                    component: "covid19",
                    PageTitle: "COVID-19 Response"
                    //TODO: Update w/ proper permission
                    //requiredPermissions: "Covid:View"
                });
        }
    ]);

    app.component("covid19",
        {
            templateUrl: "App/Resources/Covid19/covid19.html",
            controller: covid19Ctrl,
            bindings: {

            }
        });

    covid19Ctrl.$inject = ["amplitudeService", "$cookies", "covid19Constant", "covid19Factory", "emailApi", "figToaster", "$mdDialog", "$q"];


    function covid19Ctrl(amplitudeService, $cookies, covid19Constant, covid19Factory, emailApi, figToaster, $mdDialog, $q) {

        var $ctrl = this;

        ng.extend($ctrl, {
            ui: {
                submitting: false,
                searchText: '',
                lastAccessDate: moment().subtract(2, "days")
                //lastAccessDate: $cookies.get("last-access-date")
                //    ? $cookies.get("last-access-date")
                //    : moment().subtract(7, "days")
            },
            carrierUpdates: covid19Constant.carrierUpdates,
            categories: covid19Constant.categories,
            filterLinks: filterLinks,
            filterSubcats: filterSubcats,
            figMessages: covid19Constant.figMessages,
            // market updates moved to main categories
            //marketUpdates: covid19Constant.marketUpdates,
            latestFigMessage: _getLatestEntry(covid19Constant.figMessages),
            //latestMarketUpdate: _getLatestEntry(covid19Constant.marketUpdates)
            quickLinks: covid19Constant.quickLinks
        });

        function _getLatestEntry(array) {
            if (!array) return;
            if (array.length === 1) return array[0];
            return array.sort(function (a, b) {
                a.date - b.date;
            })[0];
        }

        function filterSubcats(subcat, searchTerm) {
            searchTerm = searchTerm.toLowerCase();
            if (subcat.title && subcat.title.toLowerCase().indexOf(searchTerm) !== -1) return true;
            if (subcat.description && subcat.description.toLowerCase().indexOf(searchTerm) !== -1) return true;
            if (subcat.links && _.find(subcat.links, function (row) { return row.url.toLowerCase().indexOf(searchTerm) !== -1 || row.title.toLowerCase().indexOf(searchTerm) !== -1; })) return true;
            return false;
        }

        function filterLinks(link, subcat, searchTerm) {
            searchTerm = searchTerm.toLowerCase();
            if (subcat.title && subcat.title.toLowerCase().indexOf(searchTerm) !== -1) return true;
            if (subcat.description && subcat.description.toLowerCase().indexOf(searchTerm) !== -1) return true;
            if (link.url && link.url.toLowerCase().indexOf(searchTerm) !== -1) return true;
            if (link.title && link.title.toLowerCase().indexOf(searchTerm) !== -1) return true;
            return false;
        }

        function _resetForm() {
            $ctrl.form = {
                message: '',
                files: []
            };

            return $q.when($ctrl.form);
        }

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };

        $ctrl.removeFilesFromUploadQueue = function (form) {
            if (form.files) return form.files = [];

            return ng.noop();
        };

        $ctrl.validateFiles = function (form, formName) {
            if (formName.$invalid) {
                var toastClass = 'is-error',
                    toastMessage = '';

                //Added custom system feedback based on form validation
                if (formName.$error.maxSize) toastMessage = 'File size cannot exceed 30MB per file. Please upload a different file.';

                if (formName.$error.pattern) toastMessage = 'File type is not supported. Please upload a different file.';

                if (formName.$error.maxFiles) toastMessage = 'You may upload up to 10 files.';

                $ctrl.removeFilesFromUploadQueue(form);

                return figToaster.showSimple(toastMessage, "top", toastClass);
            }
        };

        $ctrl.submitForm = function (form, formName) {

            if (formName.$invalid) return ng.noop();

            $ctrl.ui.submitting = true;

            var formData = new FormData();

            var promises = [];

            promises.push(formData.append('message', form.message));

            if (form.files.length) {
                form.files.forEach(function (file) {
                    promises.push(formData.append('Files[]', file, file.name));
                });
            }

            $q.all(promises)
                .then(function () {
                    return emailApi.createAndSendCovidEmail(formData)
                        .then(function () {
                            toastMessage = 'Your message was submitted successfully.';
                            toastClass = "is-success";
                            return _resetForm();
                        })
                        .catch(function (error) {
                            toastMessage = 'There was a problem submitting your message, please try again later.';
                            toastClass = "is-error";
                        });
                })
                .finally(function () {
                    $ctrl.ui.submitting = false;
                    return figToaster.showSimple(toastMessage, "top", toastClass);
                });

        };

        $ctrl.viewFaqs = function ($event) {
            return $mdDialog.show({
                targetEvent: $event,
                controller: "covidFaqsCtrl",
                controllerAs: "$ctrl",
                templateUrl: "App/Resources/Covid19/Components/Covid19Faqs/covid19-faqs.modal.html",
                clickOutsideToClose: true,
                bindToController: true
            });
        };

        $ctrl.viewMarketUpdates = function ($event, videos) {
            var data = {
                heading: 'Market Commentary With Tony Parish, ACM CIO',
                videos: videos
            };

            return $mdDialog.show({
                targetEvent: $event,
                controller: "covidMarketUpdatesCtrl",
                controllerAs: "$ctrl",
                templateUrl: "App/Resources/Covid19/Components/Covid19MarketUpdates/covid19-market-updates.modal.html",
                clickOutsideToClose: true,
                bindToController: true,
                locals: {
                    data: data
                }
            });
        };

        $ctrl.viewVideoEntries = function ($event, videos) {
            var data = {
                heading: '',
                videos: videos
            };

            if (videos === covid19Constant.figMessages) data.heading = 'FIG Messages';
            //if (videos === covid19Constant.marketUpdates) data.heading = 'Market Updates';

            return $mdDialog.show({
                targetEvent: $event,
                controller: "covidFigMessagesCtrl",
                controllerAs: "$ctrl",
                templateUrl: "App/Resources/Covid19/Components/Covid19FigMesages/covid19-fig-messages.modal.html",
                clickOutsideToClose: true,
                bindToController: true,
                locals: {
                    data: data
                }
            });
        };

        $ctrl.$onInit = function () {
            $ctrl.categories.forEach(function (cat) {
                cat.assetCount = covid19Factory.getAssetCount(cat);
            });
            _resetForm();
            $ctrl.linksRecentUpdates = covid19Factory.getLatestLinks($ctrl.ui.lastAccessDate, $ctrl.quickLinks);
            $ctrl.categoryRecentUpdates = covid19Factory.getLatestAssets($ctrl.ui.lastAccessDate, $ctrl.categories);
            $ctrl.carrierRecentUpdates = covid19Factory.getLatestAssets($ctrl.ui.lastAccessDate, $ctrl.carrierUpdates);

            $ctrl.lastDate = covid19Factory.getLatestDate();
        };
        //$ctrl.$onDestroy = function () {
        //    $cookies.put('last-access-date', moment());
        //};
    }

})(window.app, window.angular); // jshint ignore:line